import { cn } from '@/lib/utils';
import { BillRowVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import MoneyAmountList from '@/features/dashboard/bookingChanges/components/primitives/MoneyAmountList.tsx';
import OverriddenBadge from './OverriddenBadge';
import { cellClass } from './billRowStyles';

/** Kolumna 3 — kwota bieżąca nad przekreśloną kwotą sprzed zmiany. */
const AmountCell = ({ row }: { row: BillRowVm }) => (
  <div
    className={cn(
      cellClass,
      '@max-[640px]:col-start-2 @max-[640px]:row-start-1 @max-[640px]:pb-0 whitespace-nowrap text-right tabular-nums',
    )}
  >
    <div className="flex items-center justify-end gap-1.5">
      {row.overridden && <OverriddenBadge priceNote={row.priceNote} />}
      <span
        className={cn(
          'text-[15px]',
          row.amountMuted ? 'text-neutral-400' : 'font-semibold text-ink',
        )}
      >
        {row.amountLabel ?? <MoneyAmountList values={row.amount} empty="" />}
      </span>
    </div>
    {row.oldAmount.length > 0 && (
      <div className="text-[13px] text-neutral-400 line-through">
        <MoneyAmountList values={row.oldAmount} />
      </div>
    )}
  </div>
);

export default AmountCell;
